// import React from 'react';
// import {graphql} from 'react-apollo';
// import {flowRight as compose} from 'lodash';

// import queries from '../../../../../src/utils/queries'

import claseServCli from '../../../../functions/claseservcli';
// import getNumDiasMes from '../../../../functions/getnumdiasmes';
// import updColeccSI_ID from '../../../../functions/updColeccSI_ID';
import updColeccMANY from '../../../../functions/updColeccMANY';
import updColeccNO_ID from '../../../../functions/updColeccNO_ID'
import argsHc from '../../../../functions/argshc';
import argsEdCliOS from '../../../../functions/argsedclios.js';

import ajArgsAj from './ajargsaj';
import ajArgsMc from './ajargsmc';
// import rpvalidar from './rpvalidar';
// import rpArgsMvp from './rpargsmvp';
// import rpArgsPc from './rpargspc';
// import rpArgsMc from './rpargsmc';
// import rpArgsRx from './rpargsrx';


// import jsPDF from 'jspdf';
// import 'jspdf-autotable';

const MainAju = async (tipoAjuste, elementoArchAju, clienteSel, lista4, editSeqfindOneAndUpdate,
    createAjuste, createHistClienteMany, createMovClientes, editMovClientes, editCliente,
    fechaHoraHoy, checkPagoAdel, porcFact, valorparaPermRX) => {

  const nextVal = async (name) => {
    const argsUpd = {
      coleccion: name,
    }
    const response = await editSeqfindOneAndUpdate({
      variables: argsUpd
    });
    return response.data.editSeqfindOneAndUpdate.seq
  }

  //ACTUALIZAR BD
  const crudBD = async (operacionCRUD, args, i)=>{
    if(args.ctrlCampo === 'CRUD'){
        const {data} = await operacionCRUD({
        variables: args
      });
//Se utiliza para traer el _id del documento creado
      if(args.ctrl_id === 'SI_ID'){
        if(Object.values(data)[0]._id){
          return Object.values(data)[0]._id
        }else{
          return 0
        }
      }
    }else{
      if(args.ctrlCampo === "MANY"){
        await operacionCRUD({
          variables: args
        });
      }
    }
  }

  const updColecc = async (crudColecc, argsCrud, totDocCRUD)=>{
      let codigo = 0
      if(argsCrud[0].ctrl_id === 'SI_ID'){
        codigo = await crudBD(crudColecc[0], argsCrud[0], 0)
      }else{
        await crudBD(crudColecc[0], argsCrud[0], 0)
      }
      if(codigo!==0){
        for(let i=1; i<totDocCRUD; i++){
          argsCrud[i]._id = codigo
        }
      }
      for(let i=1; i<totDocCRUD; i++){
        await crudBD(crudColecc[i], argsCrud[i], i)
      }
    }

  let contrato = elementoArchAju.contrato
  let descripcion = "Ajuste positivo"
  if(tipoAjuste==="AN"){
    descripcion = "Ajuste negativo"
  }
  let concepto = elementoArchAju.concepto
  let valor = elementoArchAju.valor
  let saldoPendiente = clienteSel.saldoPendiente
  let totPagoAdelSinFrar = clienteSel.totPagoAdelSinFrar + valor
  let userLogin = sessionStorage.getItem('userLogin')
  let numDX = clienteSel.numeroOdeDX

  // let fechaHoy = new Date()
  // fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
  let fechaHoy = fechaHoraHoy.substr(0, 10)

  let numeroAjuste = await nextVal('aju')
  numeroAjuste = numeroAjuste.toString()

//Coleccion HISTCLIENTES
//Documento para coleccion
  let relacion = numeroAjuste, movimiento = "Ajuste", detalle = concepto
  let colecc = argsHc(contrato, relacion, valor, userLogin, descripcion, detalle, movimiento, fechaHoraHoy)
  let creaColecc = colecc.creaColecc

//Actualizar base de datos
  let creaColeccMany = [], creaColeccMany1 = []
  creaColecc.forEach((elemento, ii) => {
    creaColeccMany.push(elemento)
  })
  creaColeccMany1.push({histcliente: creaColeccMany})

  let updColMANY = updColeccMANY(creaColeccMany1, createHistClienteMany)
  await updColecc(updColMANY.crudColecc, updColMANY.argsCrud, updColMANY.totDocCRUD)
//FIN Coleccion HISTCLIENTES

//Coleccion AJUSTES
//Documento para coleccion
  // let tipoAjuste = "AN"
  colecc = ajArgsAj(contrato, tipoAjuste, concepto, numeroAjuste, valor, fechaHoraHoy)
  creaColecc = colecc.creaColecc

//Actualizar base de datos
  let updColNO_ID = updColeccNO_ID(creaColecc, createAjuste)
  await updColecc(updColNO_ID.crudColecc, updColNO_ID.argsCrud, updColNO_ID.totDocCRUD)
//FIN Coleccion AJUSTES

//ACTUALIZAR SALDO CLIENTE
//Coleccion a editar
  let tipoAct = "EditarCliOdeS", _id = clienteSel._id, estadoCliente = clienteSel.estadoCliente
  let cargoMensual = clienteSel.cargoMensual
  let saldoCl = parseInt(saldoPendiente, 10) + parseInt(valor, 10)
  if(tipoAjuste==="AN"){
    saldoCl = parseInt(saldoPendiente, 10) - parseInt(valor, 10)
  }

  colecc = argsEdCliOS(tipoAct, _id, estadoCliente, cargoMensual, saldoCl)
  let actColecc = colecc.actColecc

//Actualizar base de datos
  updColNO_ID = updColeccNO_ID(actColecc, editCliente)
  await updColecc(updColNO_ID.crudColecc, updColNO_ID.argsCrud, updColNO_ID.totDocCRUD)
//FIN ACTUALIZAR SALDO CLIENTE
// ACTUALIZAR totPagoAdelSinFrar SI SON aJ nEG Y TIENEN MARCADO  Procesar como Pago Adelantado
if(checkPagoAdel){
  let actPASFCli = []
  let argsUpd = {
    "tipoAct": "EditarCliPagoAdelSFAj",
    "contrato": contrato,
    "totPagoAdelSinFrar": totPagoAdelSinFrar,
    "porcFact": porcFact,
  }
  actPASFCli.push(argsUpd)
  // console.log(argsUpd)

  let numDocCRUD = 0
  let totDocCRUD = 1
  let argsCrud = []
  let crudColecc = []
  for(let iii=0; iii<totDocCRUD; iii++){
    argsCrud.push({ctrlCampo: 'NO_CRUD'})
  }
  for(let iii=0; iii<totDocCRUD; iii++){
    crudColecc.push(editCliente)
  }

  argsCrud[numDocCRUD] = actPASFCli[0]
  argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
  argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
  crudColecc[numDocCRUD] = editCliente

  await updColecc(crudColecc, argsCrud, totDocCRUD)
}
// FIN ACTUALIZAR totPagoAdelSinFrar SI SON aJ nEG Y TIENEN MARCADO  Procesar como Pago Adelantado
//Coleccion MOVCLIENTES
  creaColecc = []
//traer clase si todos los servicios de la tarifa son de la misma clase
  let claseServSig = claseServCli(clienteSel.tarifa.codigoTarifa, clienteSel.tarifa.servicios)

  // let valorAju = valor
  // if(tipoAjuste==="AN"){
  //   valorAju = valor * -1
  // }

    let valorMC = valor
    let valorPag = 0
    if(saldoCl<=0){
      valorPag = valorMC
    }
    if(saldoCl<valor&&saldoCl>0){
      valorPag = parseInt(valor, 10) - saldoCl
    }
  if(tipoAjuste==="AN"){
    valorMC = valor * -1
    valorPag = valorMC
  }

  let origen = `Ajuste positivo ${numeroAjuste}`
  if(tipoAjuste==="AN"){
    origen = `Ajuste negativo ${numeroAjuste}`
  }

  let argsAddAju = {
    "contrato": contrato,
    "fechaMov": fechaHoy,
    "tipo": "C",
    "subTipo": tipoAjuste,
    "procesado": "S",
    "nombreResumido": concepto,
    "descripcionServicio": "Ajuste",
    "descrClaseServ": claseServSig,
    "concepto": "Ajuste",
    "origen": origen,

    "saldoCliente": saldoCl,
    "valorTotal": valorMC,
    "valorAntesImptos": valorMC,
    "documento": numeroAjuste,
    "valorPagado": valorPag,
    "valorPendiente": valorMC - valorPag,
    "numeroOdeDX": 0,
    "fechaCreate": fechaHoraHoy,

    // "saldoCliente": saldoCl,
    // "valorTotal": valorAju,
    // "valorAntesImptos": valorAju,
    // "documento": numeroAjuste,
    // "valorPagado": valorAju,
    // "valorPendiente": 0,
    // "numeroOdeDX": 0,
  };
  creaColecc.push(argsAddAju)

//Actualizar base de datos
  updColNO_ID = updColeccNO_ID(creaColecc, createMovClientes)
  await updColecc(updColNO_ID.crudColecc, updColNO_ID.argsCrud, updColNO_ID.totDocCRUD)
//FIN Coleccion MOVCLIENTES

let hacerRX = false

//Actualizar coleccion MOVCLIENTES cuando saldoCl<=0
  actColecc = []
  if(saldoCl<=0){
    if(tipoAjuste==="AN"){
      hacerRX = true
      if(numDX===0){
        hacerRX = false
      }else{
        console.log(contrato, hacerRX)
      }
    }
    
    lista4.forEach((elemento1, ii) => {
      let argsUpd = {
        "contrato": contrato,
        "_id": elemento1._id,
        "procesado": elemento1.procesado,
        "concepto": elemento1.concepto,
        "numeroFra": elemento1.numeroFra,
        "numeroRC": elemento1.numeroRC,
        "numeroCE": elemento1.numeroCE,
        "numeroOdeDX": elemento1.numeroOdeDX,
        "fechaUltPago": elemento1.fechaUltPago,
        "valorUltPago": elemento1.valorUltPago,
        "documento": elemento1.documento,
        "valorPagado": elemento1.valorTotal,
        "valorPendiente": 0
      }
      actColecc.push(argsUpd)
    })
    if(actColecc.length>0){
      //Actualizar base de datos
      updColNO_ID = updColeccNO_ID(actColecc, editMovClientes)
      await updColecc(updColNO_ID.crudColecc, updColNO_ID.argsCrud, updColNO_ID.totDocCRUD)
    }
    //FIN Actualizar coleccion MOVCLIENTES cuando saldoCl<=0
  }else{
    if(tipoAjuste==="AN"){
      //Actualizar coleccion MOVCLIENTES cuando saldoCl>0
      //Coleccion a editar
      colecc = ajArgsMc(contrato, valor, lista4, valorparaPermRX, numDX)
      let actColecc = colecc.actColecc
      hacerRX = colecc.hacerRX
      console.log(contrato, hacerRX)

      //Actualizar base de datos
      updColNO_ID = updColeccNO_ID(actColecc, editMovClientes)
      await updColecc(updColNO_ID.crudColecc, updColNO_ID.argsCrud, updColNO_ID.totDocCRUD)
      //FIN Actualizar coleccion MOVCLIENTES cuando saldoCl>0
    }
  }

  const contratoAj = {contrato, hacerRX, numeroAjuste}
  // console.log(contrato)
  return contratoAj
}

export default MainAju

// export default compose(
//   // graphql(queries.query.allMovClientes, {name:'allMovClientes', options: (props) => {return {variables: {contrato: "12", orden: '_id'}}}}),

//   // graphql(queries.mutation.editOdeS, {name:'editOdeS'}),

// )(MainAju)
